import { render, staticRenderFns } from "./roleDescription.vue?vue&type=template&id=b80369ea&scoped=true"
import script from "./roleDescription.vue?vue&type=script&lang=js"
export * from "./roleDescription.vue?vue&type=script&lang=js"
import style0 from "./roleDescription.vue?vue&type=style&index=0&id=b80369ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b80369ea",
  null
  
)

export default component.exports